<app-loader *ngIf="loading"></app-loader>

<section class="user-details" *ngIf="paymentInfo" [attr.dir]="lang === 'ar' ? 'rtl' : 'ltr'">
  <div class="container-fluid px-3 px-lg-4">

    <!-- Hero: full width -->
    <div class="ud-hero">
      <div class="ud-hero__thumb">
        <img src="{{paymentInfo['frontImg']}}" alt="">
      </div>

      <div class="ud-hero__body">
        <div class="ud-hero__title-row">
          <h3 class="ud-hero__title">
            {{ paymentInfo['vehicle_name'] }}
          </h3>
          <span class="ud-status ud-status--approved">
            <ion-icon name="checkmark-circle"></ion-icon> Purchased
          </span>
        </div>
        <p class="ud-hero__location">
          <ion-icon name="location-outline"></ion-icon>
          {{ paymentInfo?.['location'] ? paymentInfo['location'] : (paymentInfo['city'] || '--') }}
        </p>
        <p class="ud-hero__payment-id">
          <ion-icon name="pricetag-outline"></ion-icon>
          Payment ID: {{ paymentInfo?.['payment_uuid'] ? paymentInfo['payment_uuid'] : '--' }}
        </p>
      </div>

      <!-- Language toggle for the spec panel below -->
      <!-- <div class="ud-hero__lang">
        <button type="button" class="ud-lang-btn" [class.ud-lang-btn--active]="lang === 'en'"
          (click)="toggleLang('en')">EN</button>
        <button type="button" class="ud-lang-btn" [class.ud-lang-btn--active]="lang === 'ar'"
          (click)="toggleLang('ar')">AR</button>
      </div> -->
    </div>

    <!-- Financial summary strip: always spans full width -->
    <div class="ud-fin-strip" *ngIf="paymentInfo?.['description_data']">
      <div class="ud-fin-chip" *ngFor="let field of financialFields">
        <span class="ud-fin-chip__icon"><ion-icon [name]="field.icon"></ion-icon></span>
        <div class="ud-fin-chip__text">
          <span class="ud-fin-chip__label">{{ field.label }}</span>
          <span class="ud-fin-chip__value">
            {{ paymentInfo['description_data']?.[field.key] ? (paymentInfo['description_data'][field.key] + ' SAR') :
            '--' }}
          </span>
        </div>
      </div>
      <div class="ud-fin-chip">
        <span class="ud-fin-chip__icon"><ion-icon name="cube-outline"></ion-icon></span>
        <div class="ud-fin-chip__text">
          <span class="ud-fin-chip__label">Delivery Date</span>
          <span class="ud-fin-chip__value">{{ paymentInfo['order_date'] | date: 'MMM d, y':'UTC +3' }}</span>
        </div>
      </div>
      <div class="ud-fin-chip">
        <span class="ud-fin-chip__icon"><ion-icon name="calendar-outline"></ion-icon></span>
        <div class="ud-fin-chip__text">
          <span class="ud-fin-chip__label">Purchase Date</span>
          <span class="ud-fin-chip__value">{{ paymentInfo['created_at'] | date: 'MMM d, y':'UTC +3' }}</span>
        </div>
      </div>
    </div>

    <!-- Three data-dense panels, all equal height, filling the page -->
    <div class="row ud-panels">

      <!-- Panel 1: Customer & Order -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="auction-content-main h-100">
          <div class="auction-content-body p-4">
            <div class="ud-section-title">
              <ion-icon name="person-circle-outline"></ion-icon> Customer
            </div>
            <div class="spec-grid spec-grid--icons spec-grid--bordered">
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="person-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Full Name</span>
                  <span class="spec-value">{{ paymentInfo['first_name'] }} {{ paymentInfo['last_name'] }}</span>
                </div>
              </div>
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="call-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Contact No</span>
                  <span class="spec-value">{{ paymentInfo['contact_number'] }}</span>
                </div>
              </div>
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="mail-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Email</span>
                  <span class="spec-value">{{ paymentInfo['email'] }}</span>
                </div>
              </div>
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="flag-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Nationality</span>
                  <span class="spec-value">{{ paymentInfo['nationality'] }}</span>
                </div>
              </div>
              <div class="spec-item" *ngIf="paymentInfo['company_name']">
                <span class="spec-item__icon"><ion-icon name="business-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Company</span>
                  <span class="spec-value">{{ paymentInfo['company_name'] }}</span>
                </div>
              </div>
              <div class="spec-item" *ngIf="paymentInfo['certificate_no']">
                <span class="spec-item__icon"><ion-icon name="document-text-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Certificate No</span>
                  <span class="spec-value">{{ paymentInfo['certificate_no'] }}</span>
                </div>
              </div>
            </div>

            <div class="ud-section-title">
              <ion-icon name="location-outline"></ion-icon> Delivery
            </div>
            <div class="spec-grid spec-grid--icons">
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="navigate-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Delivery Method</span>
                  <span class="spec-value">{{ paymentInfo['delivery'] || '--' }}</span>
                </div>
              </div>
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="location-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">City</span>
                  <span class="spec-value">{{ paymentInfo['city'] }}</span>
                </div>
              </div>
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="home-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Address 1</span>
                  <span class="spec-value">{{ paymentInfo['address_1'] }}</span>
                </div>
              </div>
              <div class="spec-item">
                <span class="spec-item__icon"><ion-icon name="home-outline"></ion-icon></span>
                <div class="spec-item__text">
                  <span class="spec-label">Address 2</span>
                  <span class="spec-value">{{ paymentInfo['address_2'] || '--' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Panel 2: Vehicle specifications (dynamic, EN/AR aware) -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="auction-content-main h-100">
          <div class="auction-content-body p-4 d-flex flex-column h-100">
            <div class="ud-section-title">
              <ion-icon name="car-sport-outline"></ion-icon> Vehicle specifications
            </div>

            <ul class="list-unstyled vspec-list">
              <ng-container *ngFor="let field of vehicleSpecFields">
                <li class="vspec-item" *ngIf="getSpecValue(field.key) as val">
                  <span class="vspec-item__icon"><ion-icon [name]="field.icon"></ion-icon></span>
                  <span class="vspec-item__label">{{ field.label }}</span>
                  <span class="vspec-item__value">
                    {{ field.isDate ? (val | date: 'MMM d, y') : val }}
                  </span>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>

      <!-- Panel 3: Documents & status -->
      <div class="col-lg-4 col-md-12 mb-4">
        <div class="auction-content-main h-100">
          <div class="auction-content-body p-4">
            <div class="ud-section-title ud-section-title--center">
              <ion-icon name="document-text-outline"></ion-icon>
              Documents of {{paymentInfo['first_name'] + ' ' + paymentInfo['last_name']}}
            </div>

            <div class="timeLineBox">
              <ul class="list-unstyled doc-list" *ngIf="paymentDocs && paymentDocs.length; else noDocs">
                <ng-container *ngFor="let document of paymentDocs; index as i">
                  <li class="doc-item" [ngClass]="{
                      'doc-item--approved': document['order_document_status'] === true,
                      'doc-item--rejected': document['order_document_status'] === false,
                      'doc-item--pending': document['order_document_status'] === null
                    }">
                    <span class="doc-item__status-icon">
                      <ion-icon *ngIf="document['order_document_status'] === true" name="checkmark-circle"></ion-icon>
                      <ion-icon *ngIf="document['order_document_status'] === false" name="close-circle"></ion-icon>
                      <ion-icon *ngIf="document['order_document_status'] === null" name="time-outline"></ion-icon>
                    </span>

                    <div class="doc-item__info">
                      <h5 class="doc-item__name">
                        {{document['document_name']}}
                      </h5>
                      <p class="doc-item__date">
                        {{document['created_at'] | date:'MMM d, y, h:mm a'}}
                      </p>
                    </div>

                    <div class="doc-item__actions">
                      <button type="button" class="btn-pill btn-pill--outline"
                        (click)="viewDocument(document['imageUrl']['presigned_url'])">
                        View
                      </button>

                      <button type="button" class="btn-pill btn-pill--green"
                        [disabled]="document['order_document_status'] === true"
                        *ngIf="document['order_document_status'] === null || document['order_document_status'] === true"
                        (click)="userDocStatusUpdate(document['doc_id'], '1', i)" [ladda]="laddaBtnStates[i]">
                        {{document['order_document_status'] === true ? 'Approved' : 'Approve'}}
                      </button>
                      <button type="button" class="btn-pill btn-pill--red"
                        [disabled]="document['order_document_status'] === false"
                        *ngIf="document['order_document_status'] === null || document['order_document_status'] === false"
                        (click)="openRejectWhyModal(rejectReasonModal, document['doc_id'], '0', i,document['document_name'])"
                        [ladda]="laddaBtnStates[i]">
                        {{document['order_document_status'] === false ? 'Rejected' : 'Reject'}}
                      </button>
                    </div>
                  </li>
                </ng-container>
              </ul>

              <ng-template #noDocs>
                <div class="ud-empty-state">
                  <ion-icon name="document-outline"></ion-icon>
                  <p>No order documents submitted yet.</p>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="ud-status-panel">
            <div class="ud-status-panel__row"
              *ngIf="enableReserve && (paymentInfo['buy_status'] !== '2' || paymentInfo['buy_status'] !== '1' )">
              <h4 class="ud-status-panel__label">
                Reserve Status: <span class="ud-status-panel__value">{{reserveStatus}}</span>
              </h4>

              <div class="ud-status-panel__actions">
                <button type="button" class="btn-pill btn-pill--green" [ladda]="laddaReserveBtn"
                  *ngIf="paymentInfo['payment_order_type_status'] === false || paymentInfo['payment_order_type_status'] === null"
                  (click)="updateReserveStatus(paymentInfo['product_id'], '1', paymentInfo['vehicle_id'])">
                  Reserve
                </button>

                <button type="button" class="btn-pill btn-pill--red" [ladda]="laddaReserveBtn"
                  *ngIf="paymentInfo['payment_order_type_status'] === true && !showSellOption"
                  (click)="updateReserveStatus(paymentInfo['product_id'], '0', paymentInfo['vehicle_id'])">
                  Unreserve
                </button>
              </div>
            </div>

            <div class="ud-sell-heading" *ngIf="showSellOption">
              <h4>{{paymentInfo['buy_status'] === '0' ? 'Sell Vehicle' : 'Vehicle Sold'}}</h4>
              <img class="paymentIcons" *ngIf="paymentInfo['buy_status'] === '0'"
                src="{{env + 'assets/img/pending-clock-icon.png'}}">
              <img class="paymentIcons" *ngIf="(paymentInfo['buy_status'] === '2' || paymentInfo['buy_status'] === '1')"
                src="{{env + 'assets/img/checkmark-flat.svg'}}">
            </div>

            <div class="ud-sell-action" *ngIf="showSellOption && paymentInfo['buy_status'] === '0'">
              <button type="button" class="btn-pill btn-pill--primary" [ladda]="laddaSellButton"
                [disabled]="(paymentInfo['buy_status'] === '2' || paymentInfo['buy_status']==='1')"
                (click)="openPDIModal(pdi)">
                Sell
              </button>
            </div>

            <div class="ud-upload-row" *ngIf="(paymentInfo['buy_status'] === '2' || paymentInfo['buy_status'] === '1')">
              <button type="button" class="btn-pill btn-pill--primary" (click)="openDocsUploadModal(DocsModal)">
                Upload Documents
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- Modal -->
<ng-template #DocsModal>
  <div class="modal-header">
    <h4 class="fs-lg fw-500 text-center">Upload Documents</h4>
    <button type="button" title="Close modal" class="btn-close close pull-right" aria-label="Close"
      (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden"><ion-icon name="close-outline"></ion-icon></span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngFor="let doc of globalDocsObj | keyvalue; index as i" class="modal-doc-row" [class]="i > 0 ? 'mt-3' : ''">
      <div class="modal-doc-row__info">
        <label for="" class="modal-doc-row__label">{{doc['key']}}</label>
        <input *ngIf="!doc['value']['available']" class="modal-doc-row__file" type="file" accept="image/jpeg, .pdf"
          (change)="getDocument($event, doc['key'])">
        <p *ngIf="doc['value']['available']" class="modal-doc-row__date">
          {{ doc['value']['uploadTime']| date:'MMM d, y, h:mm a'}}
        </p>
      </div>
      <div class="modal-doc-row__actions">
        <button *ngIf="!doc['value']['available']" class="btn-pill btn-pill--primary"
          [disabled]="!doc['value']['enableUpload']" [ladda]="laddaBtnStatesInModal[i]"
          (click)="uploadDocument(paymentInfo['product_id'], doc['key'], i)" title="Upload {{doc['key']}}">
          Upload
        </button>
        <button *ngIf="doc['value']['available']" class="btn-pill btn-pill--outline"
          (click)="viewDocument(doc['value']['imageUrl'])" title="View {{doc['key']}}">
          View
        </button>
        <button [disabled]="!doc['value']['available']" class="btn-pill btn-pill--red"
          [ladda]="laddaBtnStatesInModal[i]" (click)="deleteAfterSellDocs(productId, doc['value']['id'], doc['key'], i)"
          title="Delete {{doc['key']}}">
          Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #rejectReasonModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left p-0 fs-lg">Why reject {{rejectedDocName}}?</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden"><ion-icon name="close-outline"></ion-icon></span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <textarea class="w-100 border reject-txt-area p-2 text-dark" cols="30" rows="10" [(ngModel)]="whyReject"
        placeholder="Please describe why document is rejected"></textarea>
      <div class="d-flex flex-row-reverse mt-2">
        <button class="btn-pill btn-pill--primary ml-2" [ladda]="rejectLaddaBtn"
          (click)="onSubmitReject()">Submit</button>
        <button class="btn-pill btn-pill--outline" (click)="modalRef?.hide()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- PDI Modal -->
<ng-template #pdi>
  <div class="modal-header">
    <h4 class="modal-title pull-left">PDI Modal</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden"><ion-icon name="close-outline"></ion-icon></span>
    </button>
  </div>
  <div class="modal-body">

    <div class="d-flex flex-column align-items-center" *ngIf="employeeList.length; else loadingEmployeeList">
      <label class="fs-md fw-300 mb-2 credential2__label">Please select an employee</label>
      <select class="credential2__select form-control w-auto" (change)="onOptionChanged($event.target.value)">
        <option value="">Select an employee</option>
        <option *ngFor="let employee of employeeList; index as i" [value]="i">{{employee['first_name'] + ' ' +
          employee['last_name']}}</option>
      </select>
      <button class="btn-pill btn-pill--green mt-3" [ladda]="laddaSellButton" [disabled]="employeePhone === ''"
        (click)="completeSell()">Done</button>
    </div>

    <ng-template #loadingEmployeeList>
      <p>Loading...</p>
    </ng-template>

  </div>
</ng-template>